import React from 'react';

import { useGetSVGContent } from '../../hooks/misc';

export type SVGIconColor = 'primary' | 'success' | 'error' | 'yellow' | 'orange' | 'dark' | 'grey' | 'dark_grey' | 'white' | 'black';
type SVGIconHoverColor = 'primary' | 'dark_grey';

interface SVGIconProps {
    src: string | null;
    color?: SVGIconColor;
    hoverColor?: SVGIconHoverColor;
    rotation?: 0 | 90 | 180 | 270;
};
export const SVGIcon = (props: SVGIconProps) => {
    const { src, color = 'dark_grey', hoverColor, rotation = 0 } = props;

    const { data: svgContent } = useGetSVGContent(src);

    const getClassName = () => {
        let baseClass = 'immployer_admin__icon';
        if (color) baseClass += ` immployer_admin__icon__${color}`;
        if (hoverColor) baseClass += ` immployer_admin__icon__hover_${hoverColor}`;
        if (rotation !== undefined) baseClass += ` immployer_admin__icon__rotation_${rotation}deg`;
        if (!svgContent) baseClass += ' immployer_admin__icon__loading';
        return baseClass;
    };

    return (
        svgContent
            ? <div className={getClassName()} dangerouslySetInnerHTML={{ __html: svgContent }} />
            : <div className={getClassName()} />
    );
};